export const colorSchema=["#64b5f6","#1976d2","#ef6c00","#ffd54f","#455a64","#96a6a6"]